export default "__VITE_ASSET__7b5b46c5__"